import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ToastProvider } from './components/ui/toast/ToastContext';
import ToastContainer from './components/ui/toast/ToastContainer';
import { ConfirmProvider } from './components/ui/confirmModal/ConfirmContext';
import ErrorBoundary from './components/ui/errorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <BrowserRouter>
          <ToastProvider>
            <ConfirmProvider>
              <App/>
              <ToastContainer />
            </ConfirmProvider>
          </ToastProvider>
        </BrowserRouter>
      </HelmetProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
